import { makeObservable, observable, action } from "mobx";

class AddUserModalStore {
  itemsToShare = [];
  currentSelectionType = null;
  selectedUsers = [];
  selectedPermission = "User";
  pendingGrantees = [];
  isLoadingSharing = false;
  shouldShowGranteesList = false;

  constructor() {
    makeObservable(this, {
      itemsToShare: observable,
      currentSelectionType: observable,
      selectedUsers: observable,
      selectedPermission: observable,
      pendingGrantees: observable,
      isLoadingSharing: observable,
      shouldShowGranteesList: observable,
      setSelectedUsers: action,
      setSelectedPermission: action,
      addToPendingGrantees: action,
      removePendingGrantee: action,
      updatePendingGranteePermission: action,
      closeModal: action,
    });
  }

  setSelectedUsers = (users) => {
    this.selectedUsers = users;
  };

  setSelectedPermission = (permission) => {
    this.selectedPermission = permission;
  };

  addToPendingGrantees = () => {
    if (this.selectedUsers.length === 0 || !this.selectedPermission) {
      return {
        success: false,
        title: "Invalid Selection",
        message: "Please select users and permission",
        variant: "warning",
      };
    }

    try {
      const newGrantees = this.selectedUsers.map((userObj) => ({
        grantee_uuid: userObj.user_uuid || userObj.value,
        grantee_name: userObj.full_name || userObj.label,
        grantee_type: "user",
        grantee_email: userObj.email || "",
        privileges: [
          {
            privilege_uuid: `temp-priv-${Date.now()}`,
            privilege_name: this.selectedPermission,
          },
        ],
      }));

      this.pendingGrantees = [...this.pendingGrantees, ...newGrantees];
      this.selectedUsers = [];
      this.selectedPermission = "User";

      return { success: true };
    } catch (error) {
      console.error("Error adding users to pending list:", error);
      return {
        success: false,
        message: error.message || "An unexpected error occurred",
        variant: "error",
      };
    }
  };

  removePendingGrantee = (granteeUuid) => {
    this.pendingGrantees = this.pendingGrantees.filter(
      (grantee) => grantee.grantee_uuid !== granteeUuid
    );
  };

  updatePendingGranteePermission = (granteeUuid, newPermission) => {
    const grantee = this.pendingGrantees.find(
      (g) => g.grantee_uuid === granteeUuid
    );
    if (grantee) {
      grantee.privileges[0].privilege_name = newPermission;
    }
  };

  closeModal = () => {
    this.itemsToShare = [];
    this.selectedUsers = [];
    this.selectedPermission = "";
    this.currentSelectionType = null;
    this.pendingGrantees = [];
    this.isLoadingSharing = false;
  };
}

export default AddUserModalStore;
